import React from "react";
import styles from './index.module.scss'
import WalletMenu from "./compoments/walletMenu";
import VipBenefits from "./compoments/vipBenefits";
import DepositGiftBanner from "./compoments/depositGiftBanner";
import BettingHistory from "./compoments/bettingHistory";
import WalletDetails from "./compoments/walletDetails";
import { useVipCfgList } from "../vip/hooks/useVip";
import LoadingUI from "@/compoments/loadingUI";
import { useGetBalanceData, useUserInfo, useVenueBalanceList } from "@/api/request";
import LoadingUIMain from "@/compoments/loadingUIMain";
import FadeIn from "@/compoments/fadeIn";


const CentralWallet = () => {
    const { data: userInfo, isLoading: userLoading } = useUserInfo()
    const { data: gradeData, isLoading: configLoading} = useVipCfgList()
    // 获取可用余额
    const { data, isLoading, mutate, isValidating } = useGetBalanceData()
    // 获取其它场馆余额
    const { hasBalance, allBalance, isLoading: balanceLoading, isValidating: balanceDataValidating } = useVenueBalanceList();

    return (
        <FadeIn>
        <div className={styles.centralWallet}>
            <LoadingUI loading={configLoading || isLoading} data={gradeData || data} height={700}>
            {/* 顶部vip权益 */}
            <VipBenefits gradeData={gradeData} userInfo={userInfo} />

            <div className={styles.Wallet_content}>
                {/* 中心钱包 */}
                <WalletMenu data={data} />

                <div className={styles.line}></div>

                {/* 钱包明细 */}
                <WalletDetails data={data} allBalance={allBalance} />
            </div>

            {/* 存款送豪礼 */}
            <DepositGiftBanner />

            {/* 查看投注记录 */}
            <BettingHistory />
            </LoadingUI>
        </div>
        </FadeIn>
    )
}

export default CentralWallet